const removeUtmParameters = function () {
  let url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  try {
    const urlObject = new URL(url);
    const searchParams = new URLSearchParams(urlObject.search);

    // Collect all utm_ parameter keys first to avoid iterator issues
    const utmKeys = Array.from(searchParams.keys()).filter(key => key.startsWith('utm_'));

    // Remove all utm_ parameters
    utmKeys.forEach(key => searchParams.delete(key));
    urlObject.search = searchParams.toString();
    return urlObject.toString();
  } catch (error) {
    // If URL parsing fails, return original URL
    return url;
  }
};
const getTransformedEcommLink = function () {
  let href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Continue Online';
  let existingDealXgId = arguments.length > 2 ? arguments[2] : undefined;
  let dealerWebsiteConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  let baseUrl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  let dealerId = arguments.length > 5 ? arguments[5] : undefined;
  let shouldRemoveUtmParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  if (!href) {
    return href;
  }
  const dealerIdKey = 'dealerId';
  const params = {
    ...dealerWebsiteConfig,
    utm_content: `${label.replace(/\s/g, '_').toLowerCase()}_button`,
    dealXGID: existingDealXgId,
    dealerId
  };
  if (baseUrl) {
    params.url = encodeURI(baseUrl);
  }

  // Use the URL API, but fail gracefully if URL is malformed
  let url;
  try {
    url = new URL(href);
    url.searchParams.delete('utm_content'); // deleting utm_content param to make sure right label is passed.
    url.searchParams.delete('dealXGID'); // deleting dealXGID param to make sure right value is passed.
  } catch {
    return href;
  }

  // Config features may contain duplicate keys (snake_case and camelCase)
  // So explicitly defining parameters we want to support for href manipulation
  // in a single place
  const supportedParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'dealXGID', 'url'];

  // Temporarily removes ATC-added parameters
  // for backward compatibility
  if (['autotrader.com', 'kbb.com'].includes(url.searchParams.get('utm_source')) && ['autotrader_listings', 'kbb_listings'].includes(url.searchParams.get('utm_campaign'))) {
    url.searchParams.delete('utm_source');
    url.searchParams.delete('utm_campaign');
    url.searchParams.delete('utm_medium');
  }
  // End temp code

  // Set parameters and values
  supportedParams.forEach(param => params[param] && !url.searchParams.has(param) && url.searchParams.append(param, params[param]));
  if (dealerId && !url.searchParams.has(dealerIdKey)) url.searchParams.append(dealerIdKey, dealerId);
  return shouldRemoveUtmParams ? removeUtmParameters(url.toString()) : url.toString();
};
export { getTransformedEcommLink as default };
